import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import './services.css'

const Services = (props) => {
  return (
    <div className="services-container1">
      <Helmet>
        <title>Services - Copy of iCharge web copy 2</title>
        <meta
          property="og:title"
          content="Services - Copy of iCharge web copy 2"
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/d8d38ac4-4f3e-47be-9087-cfeb299d0f93/a5b67eda-b5fa-4da5-98e7-80a54823e21a?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar
        homeLink1={
          <Fragment>
            <span className="services-text10">
              View real-time charger availability, monitor your charging
              sessions, and more
            </span>
          </Fragment>
        }
        homeLink2={
          <Fragment>
            <span className="services-text11">
              Discover one of the nation&apos;s largest public fast charging
              networks, powered by 100% renewable energy
            </span>
          </Fragment>
        }
        homeLink3={
          <Fragment>
            <span className="services-text12">How to Charge</span>
          </Fragment>
        }
        homeLink4={
          <Fragment>
            <span className="services-text13">
              Learn how to power up on the go and review our charging FAQs.
            </span>
          </Fragment>
        }
        homeLink5={
          <Fragment>
            <span className="services-text14">
              Can&apos;t find what you&apos;re looking for? Let us help you.
            </span>
          </Fragment>
        }
        aboutLink1={
          <Fragment>
            <span className="services-text15">
              From recycling to renewable energy, we&apos;re committed to
              protecting our environment.
            </span>
          </Fragment>
        }
        aboutLink2={
          <Fragment>
            <span className="services-text16">Cultivating Connection</span>
          </Fragment>
        }
        supportLink1={
          <Fragment>
            <span className="services-text17">
              <span>
                Whether you&apos;re a dedicated public charger or want to keep
                your options open,
              </span>
              <br></br>
              <span> iCharge has a plan for you.</span>
            </span>
          </Fragment>
        }
        supportLink2={
          <Fragment>
            <span className="services-text21">How to charge</span>
          </Fragment>
        }
        rootClassName="navbarroot-class-name1"
        chargingPointLink1={
          <Fragment>
            <span className="services-text22">
              Can&apos;t find what you&apos;re looking for? Let us help you
            </span>
          </Fragment>
        }
        chargingPointLink2={
          <Fragment>
            <span className="services-text23">
              Locate nearby charging points with the iCharge app and simplify
              your charging
            </span>
          </Fragment>
        }
      ></Navbar>
      <main className="services-main column align-center full-vertical-height justify-center full-width">
        <h1 className="services-text24 heading-1">Our Services</h1>
        <section className="services-service1 column align-center justify-center full-width thq-section-padding">
          <div className="services-max-width1 row full-width max-content-width">
            <div className="services-content1 column gap-5">
              <div className="column gap-5">
                <h2 className="services-text25 heading-2">Charging Service</h2>
                <p className="services-text26 sub-heading-2">
                  Charging with iCharge is simple, smart, and adapted to your
                  daily routine. Find stations across Albania, check status,
                  power, and distance in real-time. Start charging with one
                  click via the app or RFID card and monitor consumption, time,
                  and cost directly on your phone.
                </p>
              </div>
            </div>
            <div className="services-container3">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Pages/Services/p1280789%20copy-1500w.webp"
                srcSet="/Pages/Services//p1280789%20copy-1500w.webp 1200w, /Pages/Services/p1280789%20copy-tablet.webp 800w, /Pages/Services/p1280789%20copy-mobile.webp 480w"
                className="services-pasted-image1"
              />
            </div>
          </div>
        </section>
        <section className="services-service2 column align-center justify-center full-width thq-section-padding">
          <div className="services-max-width2 row full-width max-content-width">
            <div className="services-content2 column gap-5">
              <div className="column gap-5">
                <h2 className="services-text27 heading-2">
                  Roaming (International Charging)
                </h2>
                <p className="services-text28 sub-heading-2">
                  With iCharge, travel doesn’t stop at borders. Thanks to
                  partnerships with European networks, users can charge abroad
                  using the same app—no extra accounts or complications. Partner
                  stations are available in real-time, offering the same
                  seamless experience as in Albania
                </p>
              </div>
            </div>
            <div className="services-container5">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Pages/Services/p1290002-1500w.webp"
                srcSet="/Pages/Services//p1290002-1500w.webp 1200w, /Pages/Services/p1290002-tablet.webp 800w, /Pages/Services/p1290002-mobile.webp 480w"
                className="services-pasted-image2"
              />
            </div>
          </div>
        </section>
        <section className="services-service3 column align-center justify-center full-width thq-section-padding">
          <div className="services-max-width3 row full-width max-content-width">
            <div className="services-content3 column gap-5">
              <div className="column gap-5">
                <h2 className="services-text29 heading-2">
                  24/7 Technical Support
                </h2>
                <p className="services-text30 sub-heading-2">
                  Our support team is available around the clock, ensuring a
                  smooth and uninterrupted charging experience. Contact us via
                  in-app chat, email, or phone. Support is not just a
                  service—it’s part of our commitment to trust and safety.
                </p>
              </div>
            </div>
            <div className="services-container7">
              <img
                alt="pastedImage"
                sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                src="/Pages/Services/p1280817-1500w.webp"
                srcSet="/Pages/Services//p1280817-1500w.webp 1200w, /Pages/Services/p1280817-tablet.webp 800w, /Pages/Services/p1280817-mobile.webp 480w"
                className="services-pasted-image3"
              />
            </div>
          </div>
        </section>
      </main>
      <Footer rootClassName="footerroot-class-name1"></Footer>
    </div>
  )
}

export default Services
